export const PEPTIDE_CATEGORIES = [
  { key: "all", label: "All", labelKey: "peptides.catalog.categories.all", icon: "apps" },
  { key: "popular", label: "Popular", labelKey: "peptides.catalog.categories.popular", icon: "star" },
  { key: "weightLoss", label: "Weight Loss", labelKey: "peptides.catalog.categories.weightLoss", icon: "monitor_weight" },
  { key: "muscleGrowth", label: "Muscle Growth", labelKey: "peptides.catalog.categories.muscleGrowth", icon: "fitness_center" },
  { key: "recovery", label: "Recovery & Healing", labelKey: "peptides.catalog.categories.recovery", icon: "healing" },
  { key: "antiAging", label: "Anti-Aging", labelKey: "peptides.catalog.categories.antiAging", icon: "spa" },
  { key: "cognitive", label: "Cognitive", labelKey: "peptides.catalog.categories.cognitive", icon: "psychology" },
  { key: "glp", label: "GLP", labelKey: "peptides.catalog.categories.glp", icon: "medication" },
  { key: "sexualHealth", label: "Sexual Health", labelKey: "peptides.catalog.categories.sexualHealth", icon: "favorite" },
  { key: "sleep", label: "Sleep", labelKey: "peptides.catalog.categories.sleep", icon: "bedtime" },
  { key: "immune", label: "Immune Support", labelKey: "peptides.catalog.categories.immune", icon: "shield" },
  { key: "skinHair", label: "Skin & Hair", labelKey: "peptides.catalog.categories.skinHair", icon: "face" },
  { key: "energy", label: "Energy", labelKey: "peptides.catalog.categories.energy", icon: "bolt" },
  { key: "supplies", label: "Supplies", labelKey: "peptides.catalog.categories.supplies", icon: "inventory_2" },
];

export const CATEGORY_COLORS = {
  weightLoss: "peptide-cat-weightLoss",
  muscleGrowth: "peptide-cat-muscleGrowth",
  recovery: "peptide-cat-recovery",
  antiAging: "peptide-cat-antiAging",
  cognitive: "peptide-cat-cognitive",
  sexualHealth: "peptide-cat-sexualHealth",
  sleep: "peptide-cat-sleep",
  immune: "peptide-cat-immune",
  skinHair: "peptide-cat-skinHair",
  energy: "peptide-cat-energy",
  glp: "peptide-cat-weightLoss",
  supplies: "peptide-cat-recovery",
};
